import { useEffect } from "react";
import { VLActionModal } from "views/uikit/VLModal";
import { Form, Typography } from "antd";
import { UserData } from "./ChangeUserRoleModal";
import { useUserModalActions } from "./useUserModals";
import styles from "./style.module.scss";

const { Text } = Typography;

type FormValues = {
  username: string;
};

interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: UserData | null;
  onRefresh?: () => void;
}

const UserDeleteModal = ({
  isOpen,
  onClose,
  user,
  onRefresh,
}: DeleteUserModalProps) => {
  const { deleteUser, loading } = useUserModalActions({
    onRefresh,
  });
  const [form] = Form.useForm<FormValues>();

  useEffect(() => {
    if (isOpen && user) {
      form.setFieldsValue({
        username: user.username,
      });
    } else {
      form.resetFields();
    }
  }, [user, isOpen, form]);

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const handleDelete = async () => {
    if (user) {
      try {
        await deleteUser({ userId: user.id });
        handleCancel();
      } catch (err) {
        console.error("Error deleting user:", err);
      }
    }
  };

  return (
    <VLActionModal
      isOpen={isOpen}
      onClose={handleCancel}
      variant="error"
      onClick={handleDelete}
      headers={{
        title: "Delete User",
        subTitle: "Are you sure you want to delete this user?",
      }}
      actionLabel="Delete"
      loading={loading}
      showCancel
    >
      <Text className={styles.deleteModalText}>
        This will permanently delete the user account and cannot be undone.
        <br />
        <br />
        Note: All data associated with this user will be automatically
        transferred to you (Admin).
      </Text>
    </VLActionModal>
  );
};

export default UserDeleteModal;
